import React, { memo } from 'react'
import {useState} from 'react'
import RefreshIcon from '../../../assets/images/refresh.svg'
import { Card, Button, MenuItem, Select, Typography } from '../../../components'
import COUNTRIES from '../../../commons/constants/countries'
import { CardPanelContentStyled, ItemStyled } from './style'

const navigatorHasShare = navigator.share

function Panel({ updateAt, onChange, data, country, getCoviddata }) {
  const { cases, recovered, deaths, todayCases, todayDeaths } = data

  const [quantity, upQuantity] = useState(1);

  const renderCountries = (country, index) => (
    <MenuItem key={`country-${index}`} value={country.value}>
      <ItemStyled>
        <div>{country.label}</div>
        <img src={country.flag} alt={`País-${country.label}`} />
      </ItemStyled>
    </MenuItem>
  )

  const textCovid19 = `${country} teve ${cases} Casos de COVID , cujo foram ${recovered} Recuperados - Ultima atualização: ${updateAt}`

  const copyInfo = () => {
    navigator.clipboard.writeText(textCovid19)
  }

  const shareInfo = () => {
    navigator.share({
      title: `Dados do Covid19 - ${country}`,
      text: textCovid19,
      url: 'https://covid19dio.netlify.app/'
    })
  }

  const renderShareButton = (
    <div>
      <Button variant="contained" color="primary" onClick={()=> upQuantity(quantity + 1), shareInfo}>
      Compartilhar
      </Button>
    </div>
  )

  const renderCopyButton = (
    <div>
      <Button variant="contained" color="primary" onClick={copyInfo}>
      📋
      </Button>
    </div>
  )

  return (
    <Card>
      <CardPanelContentStyled>
        <div>
          <Typography 
            style={{
              marginLeft: '28px',
              fontSize: '24px',
              fontWeight: '600'
            }}
            variant="h5" component="span" color="primary">Countries
          </Typography>
          <div className="pt-2">
            <Select onChange={onChange} value={country}>
              {COUNTRIES.map(renderCountries)}
            </Select>
          </div>
        </div>
        <div>
          <Typography variant="h6" component="span" color="primary">Painel Coronavírus</Typography><br></br>
          <Typography variant="body2" component="span" color="primary">Atualizado em: {updateAt}</Typography>
        </div>
        {navigatorHasShare ? renderShareButton : renderCopyButton}
      </CardPanelContentStyled>
    </Card>
  )
}

export default memo(Panel)